const socialUrlConstructor = (id, link, text) => {
  let url = null;
  link = encodeURIComponent(link);
  switch (id) {
    case 'fb':
      url = `//facebook.com/sharer.php?u=${link}`;
      break;
    case 'twitter':
      url = `//twitter.com/intent/tweet?utm_source=twitter&utm_medium=Share&utm_campaign=twitter&text=${text}&url=${link}`;
      break;
    default:
  }

  return url;
};

export default socialUrlConstructor;
